<template>
    <div id="setting-popup" :style="popupPosition" @click.stop>
        <div class="setting-content">
            <div class="checkbox _white">
                <input type="checkbox" :checked="$store.state.settings[$route.name]['all'].value" @change="change('all', !$store.state.settings[$route.name]['all'].value)" id="settingSelectAll" />
                <label for="settingSelectAll">Выбрать все</label>
            </div>
            <div class="checkbox _white" v-for="(item, key) in $store.state.settings[$route.name]" :key="key" v-show="key != 'all'">
                <input type="checkbox" :checked="$store.state.settings[$route.name][key].value" @change="change(key, !$store.state.settings[$route.name][key].value)" :id="'option'+key" />
                <label :for="'option'+key">{{ $store.state.settings[$route.name][key].name }}</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['settings'],
        methods: {
            /* closeFilter () {
                this.$emit('closeFilter')
            }, */
            change (name, value) {
                let data = {
                    page: this.$route.name,
                    fieldName: name,
                    value: value
                }
                this.$store.commit('settings/update_cols', data)
            }
        },
        computed: {
            popupPosition () {
                return {
                    left: this.settings.left + 'px'
                }
            }
        }
    }
</script>